module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"tooltip-deleted":"wurde gelöscht"},"fr":{"tooltip-deleted":"a été effacé"},"it":{"tooltip-deleted":"cancellato"}}')
  delete Component.options._Ctor
}
